import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=1f9da89c&scoped=true&"
import script from "./Cell.vue?vue&type=script&lang=js&"
export * from "./Cell.vue?vue&type=script&lang=js&"
import style0 from "./Cell.vue?vue&type=style&index=0&id=1f9da89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9da89c",
  null
  
)

export default component.exports